module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueSvgIcon=e():t.VueSvgIcon=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/dist/",e(e.s=0)}([function(t,e,n){t.exports=n(1)},function(t,e,n){function r(t){n(2)}var i=n(7)(n(8),n(9),r,"data-v-7ef413f4",null);t.exports=i.exports},function(t,e,n){var r=n(3);"string"==typeof r&&(r=[[t.i,r,""]]),r.locals&&(t.exports=r.locals);n(5)("1b2a5eed",r,!0)},function(t,e,n){e=t.exports=n(4)(),e.push([t.i,".svg-icon[data-v-7ef413f4]{display:inline-block;width:16px;height:16px;color:inherit;vertical-align:middle;fill:none;stroke:currentColor}.svg-fill[data-v-7ef413f4]{fill:currentColor;stroke:none}.svg-up[data-v-7ef413f4]{transform:rotate(-90deg)}.svg-right[data-v-7ef413f4]{transform:rotate(0deg)}.svg-down[data-v-7ef413f4]{transform:rotate(90deg)}.svg-left[data-v-7ef413f4]{transform:rotate(180deg)}",""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},i=0;i<this.length;i++){var o=this[i][0];"number"==typeof o&&(r[o]=!0)}for(i=0;i<e.length;i++){var s=e[i];"number"==typeof s[0]&&r[s[0]]||(n&&!s[2]?s[2]=n:n&&(s[2]="("+s[2]+") and ("+n+")"),t.push(s))}},t}},function(t,e,n){function r(t){for(var e=0;e<t.length;e++){var n=t[e],r=l[n.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](n.parts[i]);for(;i<n.parts.length;i++)r.parts.push(o(n.parts[i]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length)}else{for(var s=[],i=0;i<n.parts.length;i++)s.push(o(n.parts[i]));l[n.id]={id:n.id,refs:1,parts:s}}}}function i(){var t=document.createElement("style");return t.type="text/css",f.appendChild(t),t}function o(t){var e,n,r=document.querySelector('style[data-vue-ssr-id~="'+t.id+'"]');if(r){if(p)return v;r.parentNode.removeChild(r)}if(g){var o=h++;r=d||(d=i()),e=s.bind(null,r,o,!1),n=s.bind(null,r,o,!0)}else r=i(),e=a.bind(null,r),n=function(){r.parentNode.removeChild(r)};return e(t),function(r){if(r){if(r.css===t.css&&r.media===t.media&&r.sourceMap===t.sourceMap)return;e(t=r)}else n()}}function s(t,e,n,r){var i=n?"":r.css;if(t.styleSheet)t.styleSheet.cssText=m(e,i);else{var o=document.createTextNode(i),s=t.childNodes;s[e]&&t.removeChild(s[e]),s.length?t.insertBefore(o,s[e]):t.appendChild(o)}}function a(t,e){var n=e.css,r=e.media,i=e.sourceMap;if(r&&t.setAttribute("media",r),i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}var c="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!c)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var u=n(6),l={},f=c&&(document.head||document.getElementsByTagName("head")[0]),d=null,h=0,p=!1,v=function(){},g="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports=function(t,e,n){p=n;var i=u(t,e);return r(i),function(e){for(var n=[],o=0;o<i.length;o++){var s=i[o],a=l[s.id];a.refs--,n.push(a)}e?(i=u(t,e),r(i)):i=[];for(var o=0;o<n.length;o++){var a=n[o];if(0===a.refs){for(var c=0;c<a.parts.length;c++)a.parts[c]();delete l[a.id]}}}};var m=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t,e){for(var n=[],r={},i=0;i<e.length;i++){var o=e[i],s=o[0],a=o[1],c=o[2],u=o[3],l={id:t+":"+i,css:a,media:c,sourceMap:u};r[s]?r[s].parts.push(l):n.push(r[s]={id:s,parts:[l]})}return n}},function(t,e){t.exports=function(t,e,n,r,i){var o,s=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(o=t,s=t.default);var c="function"==typeof s?s.options:s;e&&(c.render=e.render,c.staticRenderFns=e.staticRenderFns),r&&(c._scopeId=r);var u;if(i?(u=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),n&&n.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(i)},c._ssrRegister=u):n&&(u=n),u){var l=c.functional,f=l?c.render:c.beforeCreate;l?c.render=function(t,e){return u.call(e),f(t,e)}:c.beforeCreate=f?[].concat(f,u):[u]}return{esModule:o,exports:s,options:c}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r={},i=[],o="",s="";e.default={data:function(){return{loaded:!1}},props:{icon:String,name:String,width:{type:String,default:""},height:{type:String,default:""},scale:String,dir:String,fill:{type:Boolean,default:!0},color:String},computed:{clazz:function(){var t="svg-icon";return this.fill&&(t+=" svg-fill"),this.dir&&(t+=" svg-"+this.dir),t},iconName:function(){return this.name||this.icon},iconData:function(){return this.iconName&&this.loaded?r[this.iconName]:null},colors:function(){return this.color?this.color.split(" "):""},path:function(){var t=this;if(this.iconData){var e=/<(path|rect|circle|polygon|line|polyline|ellipse)\s/gi;if(this.colors&&this.colors.length>0){var n=0;return this.iconData.data.replace(e,function(e){var r=t.colors[n++]||t.colors[t.colors.length-1],i=t.fill;return r&&0===r.indexOf("r-")&&(i=!i,r=r.split("r-")[1]),e+(i?"fill":"stroke")+'="'+r+'" '+(i?"stroke":"fill")+'="none" '})}return this.iconData.data}return i.push({name:this.iconName,component:this}),""},box:function(){var t=this.width||16,e=this.width||16;return this.iconData?this.iconData.viewBox?this.iconData.viewBox:"0 0 "+this.iconData.width+" "+this.iconData.height:"0 0 "+parseFloat(t)+" "+parseFloat(e)},style:function(){var t=/^\d+$/,e=Number(this.scale),n=void 0,r=void 0;return!isNaN(e)&&this.iconData?(n=Number(this.iconData.width)*e+"px",r=Number(this.iconData.height)*e+"px"):(n=t.test(this.width)?this.width+"px":this.width,r=t.test(this.height)?this.height+"px":this.height),{width:n||o,height:r||s}}},created:function(){r[this.iconName]&&(this.loaded=!0)},install:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.tagName||"svgicon";e.defaultWidth&&(o=e.defaultWidth),e.defaultHeight&&(s=e.defaultHeight),t.component(n,this)},register:function(t){for(var e in t)!function(e){r[e]||(r[e]=t[e]),i=i.filter(function(t,n){return t.name===e&&t.component.$set(t.component,"loaded",!0),t.name!==e})}(e)},icons:r}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement;return(t._self._c||e)("svg",{class:t.clazz,style:t.style,attrs:{version:"1.1",viewBox:t.box},domProps:{innerHTML:t._s(t.path)}})},staticRenderFns:[]}}])});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return panDetect; });
/**
 * find closest matched selector
 */
var closest = function closest(el, selector) {
  el = getElement(el);
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

  while (el) {
    if (matchesSelector.call(el, selector)) {
      break;
    }
    el = el.parentElement;
  }
  return el;
};

/**
 * detect PanDetect
 */
var panDetect = function panDetect(callback) {
  // credit: http://www.javascriptkit.com/javatutors/touchevents2.shtml
  var xDown = null;
  var yDown = null;
  var startTarget = null;

  document.addEventListener('touchstart', handleTouchStart, false);
  document.addEventListener('touchmove', handleTouchMove, false);

  function handleTouchStart(evt) {
    startTarget = evt.target;
    xDown = evt.touches[0].clientX;
    yDown = evt.touches[0].clientY;
  };

  function handleTouchMove(evt) {
    if (!xDown || !yDown) {
      return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    var direction = 'none';

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /* most significant*/
      if (xDiff > 0) {
        /* left swipe */
        direction = 'left';
      } else {
        /* right swipe */
        direction = 'right';
      }
    } else {
      if (yDiff > 0) {
        /* up swipe */
        direction = 'up';
      } else {
        /* down swipe */
        direction = 'down';
      }
    }
    /* reset values */
    xDown = null;
    yDown = null;

    callback({
      direction: direction,
      startTarget: startTarget
    }, unregister);
  };

  function unregister() {
    document.removeEventListener('touchstart', handleTouchStart);
    document.removeEventListener('touchmove', handleTouchMove);
  }
};

function getElement(el) {
  return Object.prototype.toString.call(el) === '[object String]' ? document.querySelector(el) : el;
}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function () {
    var Helper = {
        getTimestamp: function getTimestamp() {
            return new Date().getTime();
        },
        getRandomKey: function getRandomKey() {
            return 'vue-touch-' + (Math.random() + '').replace(/\D/g, '');
        },
        getType: function getType(start, end) {
            var type = null;
            var ratio = Math.min(2, window.devicePixelRatio);
            var during = end.T - start.T;
            var h = (end.X - start.X) / ratio;
            var v = (end.Y - start.Y) / ratio;
            var absh = Math.abs(h);
            var absv = Math.abs(v);
            var move = Math.sqrt(Math.pow(h, 2) + Math.pow(v, 2));
            switch (true) {
                case during < 3:
                    break;
                case during > 500 && move < 20:
                    type = 'long';
                    break;
                case move < 6:
                    type = 'tap';
                    break;
                case h > 0 && absv < 35:
                    type = 'right';
                    break;
                case h < 0 && absv < 35:
                    type = 'left';
                    break;
                case v > 0 && absv > absh:
                    type = 'down';
                    break;
                case v < 0 && absv > absh:
                    type = 'up';
                    break;
                default:
            }
            return type;
        },
        getEventName: function getEventName() {
            return isMobile ? {
                start: 'touchstart',
                end: 'touchend'
            } : {
                start: 'mousedown',
                end: 'mouseup'
            };
        },
        attachEvent: function attachEvent(el, handler, capture) {
            var event = Helper.getEventName();
            el.addEventListener(event.start, handler.start, capture);
            el.addEventListener(event.end, handler.end, capture);
        },
        detachEvent: function detachEvent(el, handler) {
            var event = Helper.getEventName();
            el.removeEventListener(event.start, handler.start);
            el.removeEventListener(event.end, handler.end);
        }
    };
    var vueTouch = {};
    var isMobile = 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 || /(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone)/i.test(navigator.userAgent);
    var modifierRules = function modifierRules(dom, e, modifiers) {
        /* 禁止冒泡 */
        modifiers.stop && e.stopPropagation();
        /* 阻止默认事件 */
        modifiers.prevent && e.preventDefault();
        /* 元素本身事件 */
        if (modifiers.self && dom !== e.target) {
            return false;
        }
        return true;
    };
    var newHandler = function newHandler(type) {
        return {
            start: function start(e) {
                var key = this['vue-touch-id'];
                var data = workSpace[key][type];
                var method = data.method;
                var modifiers = data.modifiers;
                var start = data.start;
                if (isMobile) {
                    start.X = e.touches[0].pageX;
                    start.Y = e.touches[0].pageY;
                } else {
                    start.X = e.screenX;
                    start.Y = e.screenY;
                }
                start.T = Helper.getTimestamp();
                /* 修饰符策略 */
                if (!modifierRules(this, e, modifiers)) {
                    return false;
                }
                /* 周期开始 */
                data.cycle = 1;
                /* 长按计时器 */
                if (type === 'long') {
                    if (data.timer) clearTimeout(data.timer);
                    data.timer = setTimeout(function () {
                        data.cycle < 3 && method(e);
                        data.timer = 0;
                    }, 300);
                }
            },
            end: function end(e) {
                var end = {
                    X: 0,
                    Y: 0,
                    T: Helper.getTimestamp()
                };
                if (isMobile) {
                    end.X = e.changedTouches[0].pageX;
                    end.Y = e.changedTouches[0].pageY;
                } else {
                    end.X = e.screenX;
                    end.Y = e.screenY;
                }

                var key = this['vue-touch-id'];
                var data = workSpace[key][type];
                var method = data.method;
                var modifiers = data.modifiers;
                var start = data.start;
                /* 周期完成 */
                data.cycle = 3;
                if (!type || Helper.getType(start, end) !== type) return false;
                /* 修饰符策略 */
                if (!modifierRules(this, e, modifiers)) {
                    return false;
                }
                /* 事件执行 */
                type !== 'long' && method(e, start, end);
                /* 单次执行结束后释放事件及数据 */
                if (modifiers.once) {
                    Helper.detachEvent(this, data.handler);
                    delete workSpace[key][type];
                }
                /* 执行 afterEvent Hook */
                if (afterEvent !== null) {
                    afterEvent(this, type, e);
                }
            }
        };
    };
    var afterEvent = null;
    var workSpace = {};

    vueTouch.install = function (Vue, options) {
        if (options && options.afterEvent && typeof options.afterEvent === 'function') afterEvent = options.afterEvent;
        Vue.directive('touch', {
            bind: function bind(el, binding) {
                var type = binding.arg;
                var modifiers = binding.modifiers;
                var capture = !!modifiers.capture;
                var method = binding.value;
                var key = '';

                if (typeof binding.value !== 'function' || !binding.arg) {
                    return console.error('[Vue warn]: Invalid parameter, Expected Function.');
                }

                if (el.hasOwnProperty('vue-touch-id')) {
                    key = el['vue-touch-id'];
                } else {
                    key = el['vue-touch-id'] = Helper.getRandomKey();
                    workSpace[key] = {};
                }
                var handler = newHandler(type);
                workSpace[key][type] = {
                    method: method,
                    modifiers: modifiers,
                    handler: handler,
                    start: {
                        X: 0,
                        Y: 0,
                        T: 0
                    },
                    timer: 0,
                    cycle: 0
                };
                Helper.attachEvent(el, handler, capture);
            },
            update: function update(el, binding) {
                var type = binding.arg;
                var method = binding.value;
                var key = el['vue-touch-id'];
                var data = workSpace[key];
                if (data.hasOwnProperty(type)) {
                    data[type].method = method;
                }
            },
            unbind: function unbind(el) {
                var key = el['vue-touch-id'];
                var data = workSpace[key];
                for (var i in data) {
                    if (data.hasOwnProperty(i) && i) {
                        Helper.detachEvent(el, data[i].handler);
                    }
                }
                delete workSpace[key];
            }
        });
    };

    if (( false ? 'undefined' : _typeof(exports)) == "object") {
        module.exports = vueTouch;
    } else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return vueTouch;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (window.Vue) {
        window.vueTouch = vueTouch;
        Vue.use(vueTouch);
    }
}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(17),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(18),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueSvgIconPolyfill=t():e.VueSvgIconPolyfill=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/dist/",t(t.s=0)}([function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};"object"===("undefined"==typeof document?"undefined":o(document))&&"string"!=typeof document.createElementNS("http://www.w3.org/2000/svg","svg").innerHTML&&Object(r.a)()},function(e,t,n){"use strict";t.a=function(){var e=function e(t,n){var r=t.nodeType;if(3==r)n.push(t.textContent.replace(/&/,"&amp;").replace(/</,"&lt;").replace(">","&gt;"));else if(1==r){if(n.push("<",t.tagName),t.hasAttributes())for(var o=t.attributes,i=0,s=o.length;i<s;++i){var u=o.item(i);n.push(" ",u.name,"='",u.value,"'")}if(t.hasChildNodes()){n.push(">");for(var f=t.childNodes,i=0,s=f.length;i<s;++i)e(f.item(i),n);n.push("</",t.tagName,">")}else n.push("/>")}else{if(8!=r)throw"Error serializing XML. Unhandled node of type: "+r;n.push("\x3c!--",t.nodeValue,"--\x3e")}};Object.defineProperty(SVGElement.prototype,"innerHTML",{get:function(){for(var t=[],n=this.firstChild;n;)e(n,t),n=n.nextSibling;return t.join("")},set:function(e){for(;this.firstChild;)this.removeChild(this.firstChild);try{var t=new DOMParser;t.async=!1;for(var n="<svg xmlns='http://www.w3.org/2000/svg'>"+e+"</svg>",r=t.parseFromString(n,"text/xml").documentElement,o=r.firstChild;o;)this.appendChild(this.ownerDocument.importNode(o,!0)),o=o.nextSibling}catch(e){throw console.error(e),new Error("Error parsing XML string")}}}),Object.defineProperty(SVGElement.prototype,"innerSVG",{get:function(){return this.innerHTML},set:function(e){this.innerHTML=e}})}}])});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compiled_icons__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compiled_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__compiled_icons__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name']
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_libs_utils__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'keyboard',

  props: ['show', 'point', 'activeOk', 'okText'],

  methods: {
    typing: function typing(e) {
      e.preventDefault();

      var td = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_libs_utils__["a" /* closest */])(e.target, 'td');

      if (!td) return;

      var code = td.dataset.code || td.textContent;

      if (!code) return;

      this.$emit('typing', code);
    },
    longTab: function longTab(e) {
      e.preventDefault();

      var td = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_libs_utils__["a" /* closest */])(e.target, 'td');

      if (!td) return;

      var code = td.dataset.code || td.textContent;

      if (!code) return;

      if (code === 'D') {
        code = 'LD';
      }

      this.$emit('typing', code);
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keyboard__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keyboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__keyboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_libs_utils__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'keyboardInput',

  props: {
    /**
     * raise page height if expose elemenet is covered by keyboard
     * {string} - optional
     * default - keyboardInput
     */
    'exposeElem': String,
    /**
     * digital point display control
     * {boolean} - optional
     * default - true
     */
    'point': {
      type: Boolean,
      default: true
    },
    /**
     * v-model value
     */
    'value': {
      type: [String, Number],
      default: ''
    },
    /**
     * ok button text
     */
    'okText': String,
    /**
     * placeholder
     */
    'placeholder': {
      type: String,
      default: ''
    },
    /**
     * start from left or right
     */
    'textAlign': {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      showClear: this.textAlign === 'left',
      showKeyboard: false,
      hasEventCallback: false,
      mutableValue: '',
      orgHeight: '' // original body height property
    };
  },


  methods: {
    typing: function typing(code) {
      // set value, insure sync
      var mutableValue = this.value;

      if (code === 'D') {
        // del
        mutableValue = mutableValue.substring(0, mutableValue.length - 1);
        this.$emit('input', mutableValue);
      } else if (code === 'LD') {
        // long del
        mutableValue = '';
        this.$emit('input', mutableValue);
      } else if (code === 'F') {
        // fold
        this.blur();
        this.$emit('onFold', mutableValue);
      } else if (code === 'K') {
        // ok
        this.blur();
        this.$emit('onOk', mutableValue);
      } else if (/[0-9\.]/.test(code)) {
        // normal input
        mutableValue += code;
        this.$emit('input', mutableValue);
      }
    },
    focus: function focus(e) {
      e.preventDefault();

      if (!this.showKeyboard) {
        // avoid dup click input
        this.showKeyboard = true;
        this.adaptPageHeight();
        this.registerEvents();
      }
    },
    blur: function blur() {
      if (this.showKeyboard) {
        this.resetPageHeight();
      }
      this.showKeyboard = false;
    },
    clear: function clear() {
      this.$emit('input', '');
    },


    /**
     * raise page height
     */
    adaptPageHeight: function adaptPageHeight() {
      var exposeElem = document.querySelector(this.exposeElem) || this.$refs.keyboardInput;
      var keyboard = this.$refs.keyboard.$el;
      var win = window;
      var body = document.body;
      var rect = exposeElem.getBoundingClientRect();
      var diffHeight = keyboard.clientHeight - (win.innerHeight - rect.top - exposeElem.clientHeight);
      if (diffHeight > 0) {
        this.orgHeight = body.style.height;
        diffHeight += 30; // 30: additional gap
        body.style.height = body.clientHeight + diffHeight + 'px';
        body.style.removeProperty('transition'); // scrollTop will fail when height has transition
        win.scrollTo(0, diffHeight);
      }
    },


    /**
     * resetPageHeight
     */
    resetPageHeight: function resetPageHeight() {
      var body = document.body;
      body.style.transition = 'height 0.2s';
      if (this.orgHeight) {
        body.style.height = this.orgHeight;
      } else {
        body.style.removeProperty('height');
      }
    },


    /**
     * register events
     */
    registerEvents: function registerEvents() {
      this.registerBlur();
      this.registerPanDown();
    },


    /**
     * blur
     */
    registerBlur: function registerBlur() {
      var _this = this;

      if (!this.hasEventCallback) {
        var callback = function callback(e) {
          if (!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_libs_utils__["a" /* closest */])(e.target, '.keyboard') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_libs_utils__["a" /* closest */])(e.target, '.keyboard-input'))) {
            _this.blur();
            _this.hasEventCallback = false;
            document.removeEventListener('click', callback);
          }
        };
        this.hasEventCallback = true;
        document.addEventListener('click', callback, false);
      }
    },


    /**
     * detect touch down
     */
    registerPanDown: function registerPanDown() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_libs_utils__["b" /* panDetect */])(function (_ref, unregister) {
        var direction = _ref.direction,
            startTarget = _ref.startTarget;

        if (direction === 'down' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_libs_utils__["a" /* closest */])(startTarget, '.keyboard')) {
          _this2.blur();
          unregister();
        }
      });
    }
  },

  components: {
    keyboard: __WEBPACK_IMPORTED_MODULE_0__keyboard___default.a
  }
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__(0);
icon.register({
  'clear': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0zM5.03 3.97a.749.749 0 1 0-1.06 1.06L5.94 7 3.97 8.97a.749.749 0 1 0 1.06 1.06L7 8.06l1.97 1.97a.749.749 0 1 0 1.06-1.06L8.06 7l1.97-1.97a.749.749 0 1 0-1.06-1.06L7 5.94 5.03 3.97z" fill-rule="evenodd"/>'
  }
});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__(0);
icon.register({
  'del': {
    width: 16,
    height: 16,
    viewBox: '0 0 48.4 36',
    data: '<path pid="0" d="M29.4 19.7l6.2 6.3 1.7-1.7-6.2-6.3 6.3-6.3-1.8-1.7-6.3 6.3-6.2-6.3-1.7 1.7 6.2 6.3-6.3 6.3 1.8 1.7 6.3-6.3zM39.9 3.2a5.3 5.3 0 0 1 5.4 5.3v19a5.3 5.3 0 0 1-5.4 5.3h-20a5.4 5.4 0 0 1-3.9-1.6L3.5 18.8a1 1 0 0 1 0-1.5L16 4.8a5.4 5.4 0 0 1 3.9-1.6h20zm0-3.2H20.7a8.6 8.6 0 0 0-6.2 2.6L1.3 15a4.2 4.2 0 0 0 0 6l13.3 12.4a8.6 8.6 0 0 0 6.1 2.6h19.2a8.5 8.5 0 0 0 8.5-8.5v-19A8.5 8.5 0 0 0 39.9 0z"/>'
  }
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
__webpack_require__(11);
__webpack_require__(12);
__webpack_require__(14);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */

var icon = __webpack_require__(0);
icon.register({
  'keyfold': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M25.2 19.2H30v-4.8h-4.8v4.8zm1.2-12h-4.8V12h4.8V7.2zm-8.4 12h4.8v-4.8H18v4.8zm1.2-12h-4.8V12h4.8V7.2zM24 48l9.6-9.6H14.4L24 48zm9.6-40.8h-4.8V12h4.8V7.2zM13.2 26.4h21.6v-4.8H13.2v4.8zM12 7.2H7.2V12H12V7.2zm20.4 12h4.8v-4.8h-4.8v4.8zM36 12h4.8V7.2H36V12zm7.2-12H4.8A4.8 4.8 0 0 0 0 4.8v24a4.8 4.8 0 0 0 4.8 4.8h38.4a4.8 4.8 0 0 0 4.8-4.8v-24A4.8 4.8 0 0 0 43.2 0zm2.4 28.8a2.4 2.4 0 0 1-2.4 2.4H4.8a2.4 2.4 0 0 1-2.4-2.4v-24a2.4 2.4 0 0 1 2.4-2.4h38.4a2.4 2.4 0 0 1 2.4 2.4v24zm-30-14.4h-4.8v4.8h4.8v-4.8z"/>'
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__numKeyboardInput__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__numKeyboardInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__numKeyboardInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_libs_icon__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_libs_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_libs_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_directive_touch__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_directive_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_directive_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_svgicon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_svgicon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_svgicon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyboard_scss__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__keyboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__keyboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_svgicon_dist_polyfill__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_svgicon_dist_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_svgicon_dist_polyfill__);







/* harmony default export */ __webpack_exports__["default"] = ({
  install: function install(Vue) {
    Vue.use(__WEBPACK_IMPORTED_MODULE_3_vue_svgicon___default.a);
    Vue.use(__WEBPACK_IMPORTED_MODULE_2_vue_directive_touch___default.a);
    Vue.component('numkeyboard-icon', __WEBPACK_IMPORTED_MODULE_1_libs_icon___default.a);
    Vue.component('numkeyboard', Vue.extend(__WEBPACK_IMPORTED_MODULE_0__numKeyboardInput___default.a));
  }
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(19),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: ['icon', 'icon-' + _vm.name]
  }, [_c('svgicon', {
    attrs: {
      "icon": _vm.name
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "numKeyboardInput"
  }, [_c('div', {
    ref: "keyboardInput",
    class: ['keyboard-input', {
      'keyboard-focus': _vm.showKeyboard
    }, _vm.textAlign],
    on: {
      "click": _vm.focus
    }
  }, [(_vm.placeholder && _vm.value === '') ? _c('span', {
    staticClass: "placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _c('span', {
    staticClass: "input-value"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('numkeyboard-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showClear && _vm.showKeyboard && _vm.value),
      expression: "showClear && showKeyboard && value"
    }],
    attrs: {
      "name": "clear"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clear($event)
      }
    }
  })], 1), _vm._v(" "), _c('keyboard', {
    ref: "keyboard",
    attrs: {
      "show": _vm.showKeyboard,
      "activeOk": !!_vm.value,
      "point": _vm.point,
      "ok-text": _vm.okText
    },
    on: {
      "typing": _vm.typing
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['keyboard', {
      hidden: !_vm.show
    }]
  }, [_c('table', {
    directives: [{
      name: "touch",
      rawName: "v-touch:tap",
      value: (_vm.typing),
      expression: "typing",
      arg: "tap"
    }, {
      name: "touch",
      rawName: "v-touch:long",
      value: (_vm.longTab),
      expression: "longTab",
      arg: "long"
    }]
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-code": "D",
      "rowspan": "2"
    }
  }, [_c('numkeyboard-icon', {
    attrs: {
      "name": "del"
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_vm._v("9")]), _vm._v(" "), _c('td', {
    class: {
      active: _vm.activeOk
    },
    attrs: {
      "data-code": "K",
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.okText || 'OK'))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.point ? '.' : ''))]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-code": "F"
    }
  }, [_c('numkeyboard-icon', {
    attrs: {
      "name": "keyfold"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("6")])])
}]}

/***/ })
/******/ ]);